<div class="container" style="margin-top: 32px;">
  <h2>Recommended courses for you</h2>
  <div class="row" style="margin:16px 0;">
    <div class="col-md-4" *ngFor="let course of suggestions">
      <app-course-card [course]="course"></app-course-card>
    </div>
  </div>
</div>
